import { Text } from "@innovationnorway/lighthouse-components";
import React from "react";
import "./myPageTag.scss";

interface MyPageTagProps {
  text: string;
  variant?: string;
}

const MyPageTag = ({ text, variant }: MyPageTagProps) => {
  return (
    <div className={`tag tag__${variant}`}>
      <Text variant="small">{text}</Text>
    </div>
  );
};

export default MyPageTag;
